exports = module.exports = require("../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-accordion[data-v-2c5c60d8]{transition:all .4s;overflow-x:hidden}.container-open[data-v-2c5c60d8]{max-height:900px}.container-close[data-v-2c5c60d8]{overflow-y:hidden;max-height:120px}.accordion[data-v-2c5c60d8]{transition:opacity .4s linear;transition-delay:0s}.open[data-v-2c5c60d8]{opacity:1%}.close[data-v-2c5c60d8]{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader?minimize!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2c5c60d8","scoped":true,"hasInlineConfig":false}!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/forms-loja/config-formaspagamento-list-loja.vue
// module id = 1911
// module chunks = 0